<template>
  <div :class="showPageRecord ? 'pagination-wrap' : ''">
    <div class="css-controls">
      <div class="page-size-select">
      <label for="pageSize">Rows per page:</label>
      <select id="pageSize" v-model="selectedPageSize" @change="updatedPageSize">
        <option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</option>
      </select>
    </div>
    <div class="page-record" v-if="from && to && total && showPageRecord">
      <span>Showing {{ from }} to {{ to }} of {{ total }} results</span>
    </div>
    </div>   
    <div class="table-pagination" v-if="items.total_records > perPage">
      <b-pagination v-if="items.total_records > 0" v-model="items.current_page" :total-rows="items.total_records"
                    :per-page="perPage" align="right" prev-text="Prev" next-text="Next" first-text="First" last-text="Last"
                    @change="handlePageChange">
      </b-pagination>
    </div>
  </div>
</template>

<script>
import Helper from "@/resource/Helper";

export default {
  name: "Pagination",
  props: {
    rows: {
      required: true,
    },
    filters: {
      default() {
        return {};
      },
    },
    showPageRecord: {
      type: Boolean,
      default: true,
    },
    renewalStatus: {
      type: Boolean,
      default: false
    },
    customSearchEvent: {
      type: String,
      default: 'searchEvent'
    },
  },

  data() {
    return {
      items: [],
      filterParams: {},
      selectedPageSize: 10,
      pageSizes: [10, 25, 50, 75, 100],
      isLoading: false
    };
  },
  methods: {
    handlePageChange(page) {
      if (this.isLoading) return;
      
      this.isLoading = true;
      const pageSize = this.selectedPageSize;
      
      try {
        // Emit the page change event with the new page and page size
        this.$emit('page-change', { 
          page, 
          pageSize,
          filterParams: this.filterParams
        });
        
        // Update local state to reflect the change
        this.$emit('update:rows', {
          ...this.items,
          current_page: page,
          per_page: pageSize
        });
      } catch (error) {
        console.error('Error handling page change:', error);
      } finally {
        this.isLoading = false;
      }
    },
    // goToUrl(url) {
    //   if (this.filterQuery) {
    //     url = url + `&${this.filterQuery}`;
    //   }
    //   this.getData(url);
    // }
    updatedPageSize() {
      this.$emit('page-size-change', this.selectedPageSize);
      this.handlePageChange(1);
    },
    onSearchEvent(data) {
      this.filterParams = data;
      this.$emit('search', data);
      this.handlePageChange(1);
    },
  },
  mounted() {
    this.$root.$on(this.customSearchEvent, this.onSearchEvent);
    /* // old static event listener
    this.$root.$on("searchEvent", (data) => {
      this.filterParams = data;
      this.handlePageChange(1);
    });
    */
  },
  beforeDestroy() {
    this.$root.$off(this.customSearchEvent, this.onSearchEvent);
  },
  computed: {
    perPage() {
      return this.items.per_page ? this.items.per_page : 10;
    },
    filterQuery() {
      return Helper.objToUrlParams(this.filterParams);
    },
    from() {
      return this.items.record_range ? this.items.record_range[0] : "";
    },
    to() {
      return this.items.record_range ? this.items.record_range[1] : "";
    },
    total() {
      return this.items.total_records ? this.items.total_records : "";
    },
  },
  created() {
    this.items = this.rows;
    this.filterParams = this.filters;
  },
  watch: {
    rows(value) {
      this.items = value;
      this.selectedPageSize = this.items.per_page;
    },
    filters(value) {
      this.filterParams = value;
    },
  },
};
</script>

<style>
.pagination-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  flex-wrap: wrap;
  gap: 6px;
}

.page-link {
  border: none !important;
  color: #778699 !important;
}

/* .page-item:last-child .page-link{
color:#29bcff !important;
} */
.page-item.active .page-link {
  background-color: unset !important;
  color: #29BCFF !important;
  border-bottom: 3px solid #29bcff !important;
}

.page-item .page-link:focus {
  box-shadow: unset !important;
}

.pagination ul li {
  font-size: 13px;
}

.page-item:first-child .page-link{
  padding-left: 0 !important;
}

/* .table-pagination {
  margin-top: -20px;
} */

/* .pagination {
  margin-top: 30px !important;
} */

@media (max-width: 768px) {
  .pagination-wrap{
      flex-wrap: wrap;
      row-gap: 0.75rem;
    }
}
@media (max-width: 499px) {
  .pagination {
    display: inline;
  }
    .page-record{
      margin-bottom: 1rem;
    }
}
.page-size-select{
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-size-select label{
  font-size: 14px;
  font-weight: bold;
}
.page-size-select select{
  padding: 4px 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.page-record{
  font-size: 14px;
}
.css-controls {
  display: flex;
  align-items: center;
  gap: 16px; 
}
</style>
<style scoped>
.page-record {
  font-size: 14px;
}

</style>
